import { type SupportedLocale } from '@abaninja/types';

import { getBrowserLanguage } from './browserLanguage';

const LANGUAGE_QUERY_PARAM = 'lang';

function getLanguageQueryParam(search: string) {
  return new URLSearchParams(search)
    .get(LANGUAGE_QUERY_PARAM)
    ?.toLowerCase();
}

export function getPreferredLanguage(search = window.location.search): SupportedLocale {
  const languageQueryParam = getLanguageQueryParam(search);

  // an unsupported query param must not shadow the browser languages
  const preferredLanguages = languageQueryParam
    ? [languageQueryParam, ...window.navigator.languages]
    : undefined;

  return getBrowserLanguage(preferredLanguages);
}
